import discoverSearchPath from "@faire/web-api--source/routes/www/discover/searchTerm";
import exploreSearchPath from "@faire/web-api--source/routes/www/explore/searchTerm";

// We need this space/dash replacements because of US SEO,
// please don't update this before checking with Growth team

export const discoverSearch = (search: string) =>
  fixedEncodeURI(discoverSearchPath(search.replace(/\s/g, "-")));

export const exploreSearch = (search: string) =>
  fixedEncodeURI(exploreSearchPath(search.replace(/\s/g, "-")));

// this function is required to match the function used in the BE: URLEncoder.encode(someUri, "UTF-8")
// which adheres to RFC 3986 stringently
const fixedEncodeURI = (URI: string) =>
  URI.replace(
    /[!'()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  );
